module.exports = __webpack_public_path__ + "img/horizontal_4_2_8019.55b1788c.png";